import { useContext } from 'react';

import { SurvicateContext } from './SurvicateContext';

export const useSurvicateContext = () => useContext(SurvicateContext);
